import React, { Component } from "react";
import { Route, Routes } from "react-router";
import { legacy_connect as connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";

import Category from "containers/Category";
import GameCategory from "containers/GameCategory";
import withRouterCompat from "utils/withRouterCompat";

import "containers/Content/styles.css";

const WrappedGameCategory = withRouterCompat(GameCategory);
const WrappedCategory = withRouterCompat(Category);

class Content extends Component {
  render() {
    return (
      <Routes>
        <Route
          path="*"
          element={
            this.props.gameLink && !this.props.isMobile ? (
              <WrappedGameCategory link={this.props.gameLink} />
            ) : (
              <WrappedCategory />
            )
          }
        />
        <Route path=":game" element={<div>load game info</div>} />
      </Routes>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let link;

  let myQT;
  let webMainLobby;
  let categoryCount;

  let isSingleCategory;

  try {
    myQT = state.pages.get("wl-pages").find((page) => {
      return page.get("rel") === "myQT";
    });
  } catch (err) {}

  try {
    webMainLobby = state.pages.get("wl-pages").find((page) => {
      return page.get("rel") === "webLobbyMain";
    });
  } catch (err) {}

  try {
    categoryCount = webMainLobby.getIn(["content"]).size;
  } catch (err) {}

  try {
    isSingleCategory = !myQT && categoryCount === 1;
  } catch (err) {}

  try {
    let pages = state.pages
      .get("wl-pages")
      .find((page) => {
        return page.get("rel") === "webLobbyMain";
      })
      .get("content");
    let page = pages.find((page) => {
      return page.get("rel") === ownProps.match.params.page;
    });
    link = page.get("links").find((link) => {
      return (
        link.get("rel") === "launch.real" || link.get("rel") === "launch.demo"
      );
    });
  } catch (err) {}

  return {
    gameLink: link,
    isSingleCategory,
    isMobile: state.window.get("isMobile"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {});
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Content);
